import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59e56f8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "title" }, "エージェントセグメント名", -1))
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_10 = { class: "sub-container" }
const _hoisted_11 = { class: "sub-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "title" }, "所属エージェント", -1))
const _hoisted_13 = { class: "sub-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "title" }, "アップロードファイル名", -1))
const _hoisted_15 = { class: "sub-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "title" }, "取込件数", -1))
const _hoisted_17 = { class: "form-inline flex-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-container",
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  id: "AgSegmentName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agSegmentName) = $event)),
                  type: "text",
                  placeholder: "エージェントセグメント名",
                  maxlength: "255",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.agSegmentName]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnUpload",
                      class: "btn btn-primary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onUpload && _ctx.onUpload(...args)))
                    }, " アップロード "),
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                      style: {"display":"none"},
                      accept: ".csv"
                    }, null, 544)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", null, _toDisplayString(_ctx.uploadFileName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", null, _toDisplayString(_ctx.updateDataCnt), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              type: "button",
              name: "btnBack",
              class: "btn btn-footer btn-primary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
            }, " 戻る "),
            _createElementVNode("button", {
              type: "button",
              name: "btnRegister",
              class: "btn btn-footer btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onRegister && _ctx.onRegister(...args)))
            }, " 登録 ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}